// EditBuyerSellerModal.tsx
import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import BuyerSellerForm from "./BuyerSellerForm";
import {
  TransactingPartyAddress,
  TransactingPartyIndividual,
  TransactingPartyJoint,
  TransactingPartyOrganization
} from "../types";

type BuyerSellerFormState = {
  individual: TransactingPartyIndividual;
  organization: TransactingPartyOrganization;
  joint: TransactingPartyJoint;
  address: TransactingPartyAddress;
  sameAsPropertyAddress: boolean;
  isJoint: boolean;
  isOrganization: boolean;
};

type Props = {
  open: boolean;
  onClose: () => void;
  onSave: (data: BuyerSellerFormState) => void;
  contactType: "Buyer" | "Seller";
};

const EditBuyerSellerModal: React.FC<Props> = ({ open, onClose, onSave, contactType }) => {
  // Init empty states
  const [individual, setIndividual] = useState<TransactingPartyIndividual>({
    firstName: "",
    middleName: "",
    lastName: "",
    gender: ""
  });

  const [organization, setOrganization] = useState<TransactingPartyOrganization>({
    name: "",
    organizationType: "",
    payeeName: "",
    vesting: "",
    address: {
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      phone: "",
      email: ""
    },
    isPayeeNameSameAsName: false
  });

  const [joint, setJoint] = useState<TransactingPartyJoint>({
    relationshipType: "",
    jointOne: { firstName: "", middleName: "", lastName: "", gender: "" },
    jointTwo: { firstName: "", middleName: "", lastName: "", gender: "" }
  });

  const [address, setAddress] = useState<TransactingPartyAddress>({
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    phone: "",
    email: ""
  });

  const [sameAsPropertyAddress, setSameAsPropertyAddress] = useState(false);
  const [isJoint, setIsJoint] = useState(false);
  const [isOrganization, setIsOrganization] = useState(false);

  const handleSave = () => {
    onSave({
      individual,
      organization,
      joint,
      address,
      sameAsPropertyAddress,
      isJoint,
      isOrganization
    });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Edit {contactType}</DialogTitle>
      <DialogContent dividers>
        <BuyerSellerForm
          individual={individual}
          setIndividual={setIndividual}
          organization={organization}
          setOrganization={setOrganization}
          joint={joint}
          setJoint={setJoint}
          address={address}
          setAddress={setAddress}
          sameAsPropertyAddress={sameAsPropertyAddress}
          setSameAsPropertyAddress={setSameAsPropertyAddress}
          isJoint={isJoint}
          setIsJoint={setIsJoint}
          isOrganization={isOrganization}
          setIsOrganization={setIsOrganization}
          contactType={contactType}
          isEdit={true}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditBuyerSellerModal;
